import React, { memo } from 'react';
import { Box, Typography, useTheme, IconButton } from '@ublend-npm/aulaui-core';

import StarIcon from '@mui/icons-material/Star';

import SpaceImageIcon from '../common/SpaceImageIcon';

import { Space } from './Spaces.types';

import { getStarredSpaceColors } from '../../colors';

interface StarredSpaceItemProps {
  space: Space;
  onUnstar: (id: string) => void;
}

const StarredSpaceItem = ({ space, onUnstar }: StarredSpaceItemProps) => {
  const { palette } = useTheme();
  return (
    <Box
      display="flex"
      alignItems="center"
      justifyContent="space-between"
      p={1.5}
      borderRadius={2}
      sx={{
        minWidth: 0,
        width: '100%',
        '&:hover': {
          bgcolor: 'action.hover',
        },
      }}
    >
      <Box
        display="flex"
        alignItems="center"
        gap={2}
        flex={1}
        sx={{ minWidth: 0 }}
      >
        <SpaceImageIcon mode={palette.mode} />
        <Box flex={1} sx={{ minWidth: 0, pr: 1 }}>
          <Typography
            variant="body1"
            sx={{
              fontWeight: '400',
              display: '-webkit-box',
              WebkitLineClamp: 2,
              WebkitBoxOrient: 'vertical',
              overflow: 'hidden',
              wordBreak: 'break-word',
            }}
          >
            {space.name}
          </Typography>
          <Typography
            variant="body2"
            color={getStarredSpaceColors(palette).textSecondary}
            noWrap
          >
            {space.date}
          </Typography>
        </Box>
      </Box>
      <IconButton
        onClick={() => onUnstar(space.id)}
        aria-label={`Unstar ${space.name}`}
        size="small"
        sx={{ color: getStarredSpaceColors(palette).starIcon }}
      >
        <StarIcon style={{ width: '20px', height: '19px' }} />
      </IconButton>
    </Box>
  );
};

export default memo(StarredSpaceItem);
